<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    cargando: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    value: {
      get() {
        return this.daysDifference(
          Date.parse(this.item.fechaInicioServicio),
          Date.parse(this.item.fechaFinServicio)
        );
      },
      set(value) {
        this.$emit("update", {
          numeroNochesAdicionales: value,
          codigoTipoHotel: this.item.codigoTipoHotel,
          serviceId: this.item.idServicioCarga,
        });
      },
    },
    label() {
      if (this.item.codigoTipoHotel === "CO") return "Inicio";
      if (this.item.codigoTipoHotel === "FI") return "Fin";
      return this.item.codigoTipoHotel; // No debería llegarse nunca acá
    },
  },
  methods: {
    formatDate(fecha) {
      const partes = fecha.slice(0, 10).split("-");
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },

    /*  Return number of days between d0 and d1.
     **  Returns positive if d0 < d1, otherwise negative.
     **
     **  e.g. between 2000-02-28 and 2001-02-28 there are 366 days
     **       between 2015-12-28 and 2015-12-29 there is 1 day
     **       between 2015-12-28 23:59:59 and 2015-12-29 00:00:01 there is 1 day
     **       between 2015-12-28 00:00:01 and 2015-12-28 23:59:59 there are 0 days
     **
     **  @param {Date} d0  - start date
     **  @param {Date} d1  - end date
     **  @returns {number} - whole number of days between d0 and d1
     **
     **  @link https://stackoverflow.com/a/7763654/6534992
     */
    daysDifference(d0, d1) {
      var diff = new Date(+d1).setHours(12) - new Date(+d0).setHours(12);
      return Math.round(diff / 8.64e7);
    },
  },
};
</script>

<template>
  <tr>
    <td>{{ label }}</td>
    <td>{{ item.nombreCiudad }}</td>
    <td>
      <select v-model="value" :disabled="cargando">
        <option :value="0">0</option>
        <option v-for="n in 2" :key="n" :value="n">{{ n }}</option>
      </select>
    </td>
    <td>
      <i v-if="cargando" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      <span v-if="!cargando && value > 0">Del {{ formatDate(item.fechaInicioServicio)}} al {{ formatDate(item.fechaFinServicio)}}</span></td>
  </tr>
</template>
 